__turbopack_context__.v({
  "highValueLabel": "r12CGa_highValueLabel",
  "highValueStar": "r12CGa_highValueStar",
});
